import React, { useState } from "react";
import { Loader2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { formatError } from "@/lib/auth";
import { AuthCard } from "@/pages/LoginPage";

export const resetToken = () => new URLSearchParams(window.location.search).get("reset");

const toSignIn = () => { window.history.replaceState(null, "", window.location.pathname); window.location.reload(); };

export default function ResetPasswordPage({ token }) {
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== confirm) return setError("Passwords don't match");
    setBusy(true);
    setError(null);
    try {
      await api.resetPassword(token, pw);
      setDone(true);
    } catch (err) {
      setError(formatError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthCard>
      {done ? (
        <div className="space-y-4" data-testid="reset-done">
          <p className="text-sm">Your password has been changed. Sign in with your new password.</p>
          <Button className="w-full" onClick={toSignIn} data-testid="reset-go-login-btn">Go to sign in</Button>
        </div>
      ) : (
        <form onSubmit={submit} className="space-y-3" data-testid="reset-form">
          <p className="text-sm text-muted-foreground">Choose a new password for your account.</p>
          <Input type="password" autoComplete="new-password" placeholder="New password (8+ characters)" value={pw} onChange={(e) => setPw(e.target.value)} required minLength={8} data-testid="reset-password-input" />
          <Input type="password" autoComplete="new-password" placeholder="Repeat new password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required data-testid="reset-confirm-input" />
          {error && <p className="text-sm text-rose-300" data-testid="reset-error">{error}</p>}
          <Button type="submit" className="w-full" disabled={busy} data-testid="reset-submit-btn">
            {busy && <Loader2 className="w-4 h-4 mr-1.5 animate-spin" />} Save new password
          </Button>
          <button type="button" onClick={toSignIn} className="text-xs text-muted-foreground hover:text-foreground" data-testid="reset-cancel-link">Back to sign in</button>
        </form>
      )}
    </AuthCard>
  );
}
